import { createSelector } from 'reselect';
import { fromJS } from 'immutable';
import { selectAskAiraDomain } from '../selector';
import { RULE_REDUCER_DOMAIN } from './constants';

export const selectRuleGenDomain = (state = fromJS({})) => selectAskAiraDomain(state)[RULE_REDUCER_DOMAIN];

export const makeSelectRuleGenData = () =>
  createSelector(selectRuleGenDomain, (substate = fromJS({})) =>
    substate.toJS(),
  );
